import React, { FC } from 'react'
import { GetStaticProps } from 'next'
import { client } from '@/lib/client'
import { PageProps } from '@/types/shared'
import { ShopPage } from '@/types/sanity'
import { NotFound } from '@/views/NotFound'
import { ShopPageView } from '@/views/ShopPageView'
import { Sentry } from '@/lib/sentry'

interface ShopPageProps extends PageProps {
  shopPage?: ShopPage
}

const ProductsIndex: FC<ShopPageProps> = ({ shopPage }) => {
  if (!shopPage) return <NotFound />
  return <ShopPageView shopPage={shopPage} />
}

/**
 * Initial Props
 */

export const getStaticProps: GetStaticProps<ShopPageProps> = async (ctx) => {
  try {
    const [shopPage, siteSettings] = await Promise.all([
      client.getShopPage(),
      client.fetchSiteSettings(),
    ])
    if (!shopPage) {
      return {
        notFound: true,
      }
    }
    return { props: { shopPage, siteSettings }, revalidate: 10 }
  } catch (e) {
    Sentry.captureException(e, 'page_fetch_error', { ctx })
    return { notFound: true, props: {}, revalidate: 1 }
  }
}

export default ProductsIndex
